import { styled } from '../../../utils/styled';
import { propStyles } from '../../../utils/propStyles';
const StyledComponent = styled<any, any>('li', 'listItem', 'autocomplete')`
    ${propStyles};
`;
StyledComponent.defaultProps = {
    fontSize: 'xs',
    fontFamily: 'body',
    fontWeight: 'normal',
    color: 'body',
    bgColor: 'white',
    paddingX: 'md',
    paddingY: 'sm',
    cursor: 'pointer',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: 'none none solid none',
    hover: {
        bgColor: 'gray200',
    },
    selected: {
        color: 'white',
        bgColor: 'primary',
    },
};
export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Autocomplete/StyledComponents/ListItem.tsx